import React from 'react';
import { Link } from 'react-router-dom';
import { canAccessTenantPage, hasPagePermission } from '../utils/permissions';
import StandardEmpty from './StandardEmpty';

/**
 * 无页面权限时展示标准「暂无访问权限」反馈（不再静默跳转）。
 */
export default function PermissionGate({
  permission,
  anyOf,
  tenantPage = false,
  children,
  redirectTo = '/welcome',
}) {
  let allowed = true;
  if (tenantPage) {
    allowed = canAccessTenantPage();
  } else {
    const codes = anyOf?.length ? anyOf : permission ? [permission] : [];
    allowed = codes.length === 0 || codes.some((code) => hasPagePermission(code));
  }

  if (!allowed) {
    return (
      <div className="flex min-h-[40vh] flex-col items-center justify-center p-8">
        <StandardEmpty variant="noAccess" />
        <Link
          to={redirectTo}
          className="mt-4 text-sm text-blue-600 hover:underline dark:text-blue-400"
        >
          返回
        </Link>
      </div>
    );
  }
  return children;
}
